import * as React from "react"
import { ExportCSV } from "components/Shared/ExportCSV"
import { useIntl } from "react-intl"
import { dashesToUnderscore } from "helpers/text"

type TimeLineDataProps = {
	interval: number
	currentDate: string
	previousDate: string
	currentAmount: number
	previousAmount: number
	percentageGrowth: number
}

type ExportTimelineProps = {
	data: TimeLineDataProps[]
	metricName: string
	subMetricName: string
	intervalName: string
}

export const getMetricExportName = (
	metricName: string,
	subMetricName: string,
	intervalName: string
) => {
	const intl = useIntl()

	const metricTranslated = intl.formatMessage(
		{ id: "phronesis.timeline.export.filename.metric" },
		{ optionId: dashesToUnderscore(metricName) }
	)

	const subMetricTranslated = subMetricName
		? intl.formatMessage(
				{ id: "phronesis.timeline.export.filename.sub_metric" },
				{ optionId: subMetricName }
		  ) + "_"
		: subMetricName

	const intervalTranslated = intl.formatMessage(
		{ id: "phronesis.timeline.export.filename.interval" },
		{ optionId: intervalName }
	)
	return `desempeño_${subMetricTranslated}${metricTranslated}_${intervalTranslated}`.toLowerCase()
}

const ExportTimeline: React.FC<ExportTimelineProps> = (props) => {
	const { metricName, subMetricName, intervalName, data } = props

	const getDataFormatted = () => {
		return data.map((d: TimeLineDataProps) => ({
			interval: d.interval,
			current_date: d.currentDate,
			previous_date: d.previousDate,
			current_amount: d.currentAmount,
			previous_amount: d.previousAmount,
			percentage_growth: d.percentageGrowth,
		}))
	}

	return (
		<ExportCSV
			fileName={getMetricExportName(metricName, subMetricName, intervalName)}
			data={getDataFormatted()}
		/>
	)
}
export default ExportTimeline
